<!-- 设备传感器详情 -->
<template>
    <div>
        <sensorsidebar></sensorsidebar>
        <div class="content">
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect">

                <div class="pl-content pdt20">
                    <historyChart ref="historychart"></historyChart>
                    <!-- <realchart ref="realchart" :nodeid="NodeId"></realchart> -->
                </div>
            </div>
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect mgt20">
                <div class="pl-title lh50 xrow ai-c jc-sb">
                    <div class="xrow ai-c">
                        <p class="fw-bd lh34 mgr15">采集时间</p>
                        <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                        <el-button type="primary" icon="el-icon-search" class="mgl15" @click="search">查询</el-button>
                    </div>
                    <div class="operate xrow ai-c jc-c">
                        <!-- <a href="javascript:void(0)" class="chart" @click="showHistoryDialog">历史曲线</a> 丨 -->
                        <a href="javascript:void(0)" class="export" v-on:click="downLoadHistory()">导出全部</a>
                    </div>
                </div>
                <div class="pl-content pdt20">
                    <el-table :data="tableData" stripe style="width: 100%" header-row-class-name="headercolumn"
                        cell-class-name="datarow" :row-class-name="tableRowClassName">
                        <el-table-column prop="rowNum" label="序号" width="80">
                        </el-table-column>
                        <el-table-column prop="FullName" label="传感器名">
                        </el-table-column>
                        <el-table-column prop="Value" label="采集值">
                        </el-table-column>
                        <el-table-column prop="ReportTime" label="采集时间">
                        </el-table-column>
                        <!-- <el-table-column prop="AlarmStateText" label="报警状态">
                        </el-table-column>
                        <el-table-column prop="AlarmEventText" label="报警事件">
                        </el-table-column>
                        <el-table-column prop="AlarmTime" label="报警时间">
                        </el-table-column> -->
                    </el-table>
                </div>
                <div class="pl-footer xrow ai-c jc-sb mgt20">
                    <div class="paging-memo" v-if="totalTableDataCount > 0">检索到 {{ totalTableDataCount }} 条记录，显示
                        第{{ (pageIndex - 1) * pageRows + 1 }}条 - 第{{ pageIndex * pageRows }}条，查询耗时 {{ tableCostTime }} 毫秒
                    </div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="pageIndex" :page-sizes="[50, 100, 200, 300, 400]"
                        layout="total, prev, pager, next,sizes, jumper" :total="totalTableDataCount">
                    </el-pagination>
                </div>
            </div>
            <historydialog ref="historydialog"></historydialog>

        </div>
    </div>
</template>

<script>
import { formatDate } from '@/common/util.js'
import { forEach } from "lodash"
import { get } from "@/utils/http";
import sensorsidebar from './sensorsidebar.vue'
import realchart from '../components/realchart'
import historydialog from '../../history/history'
import historyChart from './historyChart'
import { airParamList, airDetailList } from "@/utils/config.js"
import { objectToParams, downLoadExcel } from '@/utils/util.js'

export default {
    components: { realchart, historydialog, sensorsidebar, historyChart },

    data() {
        return {
            EncoderId: '',
            Encoder: {},
            NodeId: '',
            DataNode: {},
            tableData: [],
            totalTableDataCount: 0,
            tableCostTime: 0,
            pageRows: 50,
            pageIndex: 1,
            type: "",
            queryName: "",
            valueParamList: [],
            queryDate: [
                new Date().getTime() - 3600 * 1000 * 24 * 7,
                new Date().getTime()
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    computed: {},
    watch: {
        $route: {
            handler: function (val, oldVal) {
                //  console.log("val=",val,'old',oldVal)
                this.EncoderId = val.params.id
                this.NodeId = val.params.sid;
                const group = val.params.id;
                this.getActiveName(group);
                // this.loadDataNode()
                // this.loadHistoryData()
                // this.$refs.realchart.loadData(this.NodeId)
            }
        }
    },
    mounted() {
        //    this.EncoderId = this.$route.params.id
        //    this.NodeId = this.$route.params.sid;
        this.NodeId = this.$route.params.sid
        const Group = this.$route.params.id;

        // this.EncoderId = this.$route.params.id
        // this.Group = this.$route.params.group;
        this.getActiveName(Group);

        // this.loadDataNode()
        // this.loadHistoryData()
        // this.$nextTick(t => {
        //     this.$refs.realchart.loadData(this.NodeId)
        // })
    },
    methods: {
        getTableData() {
            this.tableData = [];
            this.totalTableDataCount = 0;
            const param = {
                // key:2304270013,
                key: this.NodeId,
                metrics: this.queryName,
                begin: formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                page: this.pageIndex,
                rows: this.pageRows
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res.data) {
                    let temp = [];
                    forEach(res.data.rows, (item, index) => {
                        let valueList = [];
                        for (var key in item) {
                            if (this.valueParamList.indexOf(key) !== -1) {
                                valueList.push(item[key])
                            }
                        }
                        //  forEach(this.valueParamList,it=>{
                        //      if(it.)
                        //  })

                        temp.push({
                            rowNum: index,
                            FullName: this.type,
                            Value: valueList.join("/"),
                            // Value:`${item.temperature20CM}/${item.temperature40CM}/${item.temperature60CM}/${item.temperature80CM}`,
                            ReportTime: item.receivedAt
                        })
                    });
                    this.tableData = temp;
                    this.totalTableDataCount = res.data.rowTotal;
                }



            })
        },
        // getOptionList(param){
        //     let temp=[{label:this.type,key:""}];
        //     forEach(airParamList,item=>{
        //         if(item.key.indexOf(param) !==-1){
        //            console.log("cccc",item)
        //            temp.push({...item,label:"土壤"+item.label});
        //         }
        //     });
        //     this.NodeId="";
        //     this.NodeOptions=temp;
        // },
        getActiveName(param) {
            // console.log("airDetailList==",airDetailList)
            forEach(airDetailList, item => {

                if (!item.showIcon && param.indexOf(item.to.params.type) !== -1) {
                    this.type = item.name;
                    this.queryName = item.to.params.queryParam;
                    this.valueParamList = item.to.params.valueParam;
                }
            })
            this.getTableData();
            this.$refs.historychart.loadData(this.NodeId, this.queryName, this.valueParamList, this.type)
            //this.getOptionList(param)
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'bg-w'
            } else {
                return 'bg-mf5'
            }
        },
        handleSizeChange(rows) {
            this.pageRows = rows
            this.loadHistoryData()
        },
        handleCurrentChange(page) {
            this.pageIndex = page
            this.loadHistoryData()
        },
        showHistoryDialog() {
            this.$refs.historydialog.show(this.NodeId, this.queryName, this.valueParamList, this.type)
        },
        downLoadHistory() {
            const param = {
                // key:2304270013,
                key: this.NodeId,
                metrics: this.queryName,
                begin: formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                page: 1,
                rows: 1000
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res && res.data && res.data.rows) {
                    let temp = [];
                    forEach(res.data.rows, (item, index) => {
                        let valueList = [];
                        for (var key in item) {
                            if (this.valueParamList.indexOf(key) !== -1) {
                                valueList.push(item[key])
                            }
                        }
                        //  forEach(this.valueParamList,it=>{
                        //      if(it.)
                        //  })

                        temp.push({
                            rowNum: index,
                            FullName: this.type,
                            Value: valueList.join("/"),
                            ReportTime: item.receivedAt
                        })
                    });
                    const obj = {
                        list: temp,
                        header: [{ label: "传感器名", name: "FullName" }, { label: "采集值", name: "Value" },
                        { label: "采集时间", name: "ReportTime" }
                        ],
                        headerTitle: temp[0].FullName + "导出表"
                    };

                    downLoadExcel(obj);
                } else {
                    this.$message({
                        message: '暂无数据导出',
                        type: 'warning'
                    });
                }



            })
        },
        loadDataNode() {
            // 加载设备的数据
            this.$request('data', 'node', {
                nodeid: this.NodeId
            }).then(res => {
                if (res.code === 1) {
                    this.DataNode = res.data
                }
            })
        },
        loadHistoryData() {
            if (this.pageIndex === 1) {
                this.tableData = []
            }
            // 加载设备的数据
            this.$request('history', 'data', {
                rows: this.pageRows,
                page: this.pageIndex,
                nodeid: this.NodeId,
                begindate:
                    this.queryDate == null
                        ? ''
                        : formatDate(this.queryDate[0], 'yyyy-MM-dd hh:mm:ss'),
                endate:
                    this.queryDate == null
                        ? ''
                        : formatDate(this.queryDate[1], 'yyyy-MM-dd hh:mm:ss')
            }).then(res => {
                if (res.code === 1) {
                    this.tableData = res.data.rows
                    this.totalTableDataCount = res.data.records
                    this.tableCostTime = res.data.costtime
                }
            })
        },
        search() {
            this.getTableData()
            // console.log(this.queryDate)
            // this.loadHistoryData()
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}

.headercolumn {
    th {
        padding: 0 0;
        line-height: 45px;
        background-color: #e2eff6;
        color: #000;
        text-align: center;
        font-size: 14px;
    }
}

.datarow {
    text-align: center;
    line-height: 45px;
    color: #181b24;
    font-size: 14px;
}

.el-table .bg-mf5>td {
    background-color: #f5f9fa !important;
    border-bottom: none;
}

.el-table .bg-w>td {
    background-color: #fff !important;
    border-bottom: none;
}

.paging-memo {
    color: #485060;
    font-size: 14px;
    line-height: 24px;
}

.operate {
    line-height: 34px;
    color: #6d7996;

    a {
        color: #6d7996;
        font-size: 14px;
        display: inline-block;
        margin-left: 10px;
    }

    .chart {
        background: url(../../../assets/his-1.png) no-repeat left center;
        padding-left: 20px;
    }

    .export {
        background: url(../../../assets/his-2.png) no-repeat left center;
        padding-left: 20px;
    }

    .other {
        background: url(../../../assets/his-3.png) no-repeat left center;
        padding-left: 20px;
    }
}

.hs-dialog {
    border-radius: 6px;
    overflow: hidden;

    .el-dialog__header {
        background: url(../../../assets/title_top.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 10px 20px;

        .el-dialog__headerbtn {
            top: 15px;
        }
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }

    .hs-dialog-title {
        font-size: 18px;
        color: white;
    }
}
</style>
